import {
  PROJECT_MILESTONE_STATUS_CREATE,
  PROJECT_MILESTONE_STATUS_CREATE_FAILURE,
  PROJECT_MILESTONE_STATUS_UPDATE,
  PROJECT_MILESTONE_STATUS_UPDATE_FAILURE,
  PROJECT_MILESTONE_STATUS_DELETE,
  PROJECT_MILESTONE_STATUS_DELETE_SUBMIT,
  PROJECT_MILESTONE_STATUS_DELETE_FAILURE
} from '../constants'

export const projectMilestoneStatusCreate = payload => ({ payload, type: PROJECT_MILESTONE_STATUS_CREATE })
export const projectMilestoneStatusCreateFailure = payload => ({ payload, type: PROJECT_MILESTONE_STATUS_CREATE_FAILURE })

export const projectMilestoneStatusUpdate = payload => ({ payload, type: PROJECT_MILESTONE_STATUS_UPDATE })
export const projectMilestoneStatusUpdateFailure = payload => ({ payload, type: PROJECT_MILESTONE_STATUS_UPDATE_FAILURE })

export const projectMilestoneStatusDelete = payload => ({ payload, type: PROJECT_MILESTONE_STATUS_DELETE })
export const projectMilestoneStatusDeleteSubmit = payload => ({ payload, type: PROJECT_MILESTONE_STATUS_DELETE_SUBMIT })
export const projectMilestoneStatusDeleteFailure = payload => ({ payload, type: PROJECT_MILESTONE_STATUS_DELETE_FAILURE })
